import * as m from 'app/api/redux-jigsaw/jigsaw-methods';
import { createJigsawReaderAction } from 'app/api/redux-jigsaw/jigsaw-action';

export const getHighlights = createJigsawReaderAction(m.GET_HIGHLIGHTS);
export const highlightCurrent = createJigsawReaderAction(m.HIGHLIGHT_CURRENT);
export const deleteHighlight = createJigsawReaderAction(m.DELETE_HIGHLIGHT);
export const updateHighlight = createJigsawReaderAction(m.UPDATE_HIGHLIGHT);
export const goToHighlight = createJigsawReaderAction(m.GO_TO_HIGHLIGHT);
